import React from 'react';

const Icon = ({ src, alt = 'ABEL Technologies', ...rest }) => {
    return <img src={src} alt={alt} {...rest} />
};

export default Icon;